// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2868":"9ac40001","3005":"a1652b54","4171":"f3beac9a","6308":"f3beac9a","6533":"e997e87f"}[chunkId] + ".chunk.css";
};